var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(-1107.956 -1570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "correct_24px",
    d: "M34.609,16.385a1.875,1.875,0,0,1,0,2.652L22.031,31.615a1.875,1.875,0,0,1-2.652,0l-5.988-5.988a1.875,1.875,0,1,1,2.651-2.651L20.7,27.638,31.957,16.385a1.875,1.875,0,0,1,2.652,0ZM48,24A24,24,0,1,1,24,0,23.987,23.987,0,0,1,48,24Zm-3.75,0A20.25,20.25,0,1,0,24,44.25,20.239,20.239,0,0,0,44.25,24Zm0,0",
    transform: "translate(1107.956 1570)",
    fill: "#2ca819"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.086222e2a389023b85e784d659cdcf22.svg";
export { ForwardRef as ReactComponent };